import '../../../../styles/_block-documents.scss';
import './ProfileStep5.scss';

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form } from 'react-redux-form';
import { history } from 'routes/history';
import { formatText, HtmlText } from 'core/i18n';
import { RoadmapNavigation } from 'components/steps/roadmapNavigation';
import { UploadFiles } from 'components/documentationInfo/UploadFiles/UploadFiles';
import { useComponentWillMount } from 'hooks/useComponentWillMount';
import { clickTaleEnd, clickTaleStart } from 'utilities/clickTale';
import { DOCUMENT_TYPES } from 'constants/documents';
import { BASE_PATH } from 'constants/index';
import { UKRANIAN } from 'constants/nationalitiesCodes';
import { PENDING_OTP, STAND_BY, TRANSFER_OTP } from 'constants/statusProcess';
import { UploadFileBox } from 'components/documentationInfo/UploadFiles/UploadFileBox';
import RadioButton from 'components/radioButton/radioButton';
import { QRDocumentationView } from 'components/newAccountSteps/profileSteps/ProfileStep5/QRDocumentationView';
import { createTitleFileUploadBox } from './createTitleFileUploadBox';
import { DocumentUploadModal } from './Modals/DocumentUploadModal';
import { WorkActivityQuestion } from './WorkActivityQuestion';
import { useModal } from 'hooks/useModal';
import { TGSS_RADIO_VALUES } from 'components/newAccountSteps/profileSteps/ProfileStep5/constants';
import { PdfModal } from 'componentsV2/PdfModal/PdfModalContainer';
import {
    doTagDocumentUpload,
    doTagFinishStepSuccess,
    doTagOnExit,
    doTagOnFileReceived,
    doTagOnFinalize,
    doTagOnRequestUpload,
    doTagOnTgssExit,
    doTagOnTgssFinalize,
    doTagRadioConsent,
    doTagRadioUpload,
} from './tagging';
import { checkIfIdentityMethodNeedsToCheckUserStatus } from 'components/newAccountSteps/profileSteps/ProfileStep5/utils/checkIfIdentityMethodNeedsToCheckUserStatus';
import { DocumentationViewContext } from 'routes/formsView/DocumentationView/context/DocumentationViewContext/DocumentationViewContext';

const INITIAL_STATE = {
    showTips: false,
    filesToUpload: [],
    filesUploaded: [],
    filesReceived: [],
    errors: [],
    showModal: false,
    sendFilesDone: null,
    blowUpFade: 'blowup-in',
    modalType: 'document',
};

const PDF_PATH = 'https://www.openbank.es/assets/static/pdf/Productos/Otros/Consulta_Tesoreria.pdf';
const PDF_FILE_NAME = 'Consentimientos_TGSS.pdf';

export const ProfileStep5Component = ({
    isAres,
    getLoanStatus,
    formActions,
    documentation,
    documentationActions,
    userProfileForm,
    userProfile,
    immStepsState,
    actions,
    ibanActions,
    modalCancelActions,
    promotionalCode,
}) => {
    const [profileStep5State, setProfileStep5State] = useState(INITIAL_STATE);
    const [showLegalInformationModal, setShowLegalInformationModal] = useState(false);
    const [isDocumentAccepted, setIsDocumentAccepted] = useState(false);
    const [isDocumentRead, setIsDocumentRead] = useState(false);
    const { isOpen, toggleModal } = useModal();
    const [modalType, setModalType] = useState('');
    const {
        investmentType,
        accountType,
        isJointHolder,
        accessToken,
        identityMethod,
        nationality,
        // eslint-disable-next-line camelcase
        withoutActivity_activity,
    } = userProfile;
    const { filesReceived, sendFilesDone, errors, filesUploaded } = profileStep5State;
    const { change } = formActions;
    const { finalizeStep, enableFinishedAndNextStep, changeCurrentStep } = actions;
    const { changeUserStatusCall } = ibanActions;
    const filesToUpload = documentation.get('filesToUpload');
    const filesInfo = documentation.get('filesInfo');
    const filesInfoObj = filesInfo.toObject();
    const isUkranian = () => nationality === UKRANIAN;
    const isTransferCertificateDocument = docId => docId === DOCUMENT_TYPES.TRANSFER_CERTIFICATE;

    let totalColumns = 0;
    let countRequired = 0;
    const initialCount = {
        countTotal: 0,
        countCurrentUploaded: 0,
        countToUpload: 0,
        totalValid: 0,
    };
    const dropzoneRef = useRef(null);

    const { shouldShowTgssConsent, shouldShowQRPage, isDocumentRetryBeenShown } = useContext(DocumentationViewContext);

    useComponentWillMount(() => {
        window.scrollTo(0, 0);

        formActions.resetValidity('userProfile.sizeAndFormatValidation');
        formActions.resetValidity('userProfile.uploadValidation');
        formActions.resetValidity('userProfile.uploadFileValidationOther');
        formActions.resetValidity('userProfile.sizeValidation');
        formActions.resetValidity('userProfile.formatValidation');

        shouldShowTgssConsent && formActions.change('userProfile.documentationTgssConsent', TGSS_RADIO_VALUES.CONSENT);

        setProfileStep5State(prevState => ({ ...prevState, filesToUpload: [...documentation.get('filesToUpload')] }));
    });

    useEffect(() => {
        clickTaleStart();

        return () => {
            clickTaleEnd();
            setProfileStep5State(INITIAL_STATE);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (shouldShowTgssConsent && userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT) {
            doTagRadioConsent();
        } else if (shouldShowTgssConsent && userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.UPLOAD) {
            doTagRadioUpload();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfile.documentationTgssConsent]);

    const finishStepAction = () => {
        const currentStep = immStepsState.get('currentStep');

        if (checkIfIdentityMethodNeedsToCheckUserStatus(identityMethod)) {
            changeUserStatusCall(accessToken, 'RETURN_STATUS').then(({ status }) => {
                change('userProfile.status', status);
                finalizeStep({
                    index: Number(currentStep),
                    finished: true,
                });

                if (status === TRANSFER_OTP || status === PENDING_OTP) {
                    changeCurrentStep({ index: currentStep + 1 });
                    enableFinishedAndNextStep();
                    change('userProfile.documentationUploaded', true);
                } else if (status === STAND_BY) {
                    change('userProfile.documentationUploaded', true);
                }
            });
        } else {
            change('userProfile.documentationUploaded', true);
            finalizeStep({
                index: Number(currentStep),
                finished: true,
            });
        }
    };

    const finishStep = () => {
        if (userProfileForm.$form.valid) {
            finishStepAction();
            doTagFinishStepSuccess(userProfile);
        }
    };

    const finishUploadRequest = () => {
        setProfileStep5State(prevState => ({ ...prevState, sendFilesDone: true }));

        if (isAres) {
            change('userProfile.documentationUploaded', true);
            getLoanStatus();
        }
        finishStep();
    };

    const inArray = (needle, haystack) => {
        const length = haystack.length;
        for (let i = 0; i < length; i++) {
            if (haystack[i] === needle) {
                return true;
            }
        }

        return false;
    };
    const onHandleManageValidation = ({ errorType, id, docTitle }) => {
        let error = false;

        formActions.setValidity('userProfile.uploadFileValidationOther', { required: true });
        if (errorType !== '') {
            if (errorType === '6002') {
                history.push(`${BASE_PATH}/errors`);
            } else {
                switch (errorType) {
                    case formatText('uploads-wrongSize'):
                        formActions.setValidity('userProfile.sizeValidation', { required: false });
                        break;
                    case formatText('uploads-wrongFormat'):
                        formActions.setValidity('userProfile.formatValidation', { required: false });
                        break;
                    case 'other':
                        formActions.setValidity('userProfile.uploadFileValidationOther', { required: false });
                        break;
                    default:
                        formActions.setValidity('userProfile.sizeAndFormatValidation', { required: false });
                        break;
                }
                if (!inArray(id, errors)) {
                    errors.push(id);
                    setProfileStep5State(prevState => ({ ...prevState, errors }));
                }
                const i = filesUploaded.indexOf(id);
                if (i !== -1) {
                    filesUploaded.splice(i, 1);
                    setProfileStep5State(prevState => ({ ...prevState, filesUploaded: [...filesUploaded] }));
                }
                error = true;
            }
        } else {
            setProfileStep5State(prevState => ({ ...prevState, sendFilesDone: true }));
            const i = errors.indexOf(id);
            if (i !== -1) {
                errors.splice(i, 1);
                setProfileStep5State(prevState => ({ ...prevState, errors }));
            }
            if (!inArray(id, filesUploaded)) {
                filesUploaded.push(id);
                setProfileStep5State(prevState => ({ ...prevState, filesUploaded: [...filesUploaded] }));
            }
        }

        if (errors.length === 0) {
            formActions.setValidity('userProfile.sizeAndFormatValidation', { required: true });
            formActions.setValidity('userProfile.sizeValidation', { required: true });
            formActions.setValidity('userProfile.formatValidation', { required: true });
        }
        formActions.setValidity('userProfile.uploadValidation', { required: true });

        if (!docTitle) return;

        doTagDocumentUpload(userProfile, docTitle, error);
    };

    const checkAndRemoveForTypeDocument = docId => {
        return filesReceived.filter(element => element.docId !== docId);
    };

    const onHandleRemovedFile = file => {
        const newFilesArr = checkAndRemoveForTypeDocument(file.docId);
        setProfileStep5State(prevState => ({ ...prevState, filesReceived: [...newFilesArr] }));
    };
    const onHandleFileReceived = (file, docId, uploadResolvers) => {
        doTagOnFileReceived(docId);
        const mappedDocuments = checkAndRemoveForTypeDocument(docId);
        setProfileStep5State(prevState => ({
            ...prevState,
            filesReceived: [...mappedDocuments, { file, docId, uploadResolvers }],
        }));
    };

    const updateProgress = (e, path, name, actions) => {
        let percent;
        if (e.lengthComputable) {
            percent = Math.ceil((e.loaded / e.total) * 100);
            actions.loadingFile(percent);
        }
        if (percent === 100) {
            actions.loadedFile(path, name);
        }
    };

    const onHandleRequestUpload = () => {
        setProfileStep5State(prevState => ({ ...prevState, sendFilesDone: 'loading' }));

        const filesToUpload =
            userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT
                ? filesReceived.filter(({ docId }) => docId !== DOCUMENT_TYPES.DAAL)
                : filesReceived;

        documentationActions.sendFiles(filesToUpload, accessToken, updateProgress, finishUploadRequest, isAres);

        doTagOnRequestUpload(userProfile, isDocumentRetryBeenShown);
    };

    const handleOnSubmit = () => {};

    const handleNavCancelAction = () => {
        modalCancelActions.showModalCancel();

        if (isAres) {
            doTagOnExit();
        }

        if (shouldShowTgssConsent) {
            doTagOnTgssExit();
        }
    };

    const isColectivos = () => {
        const colectivos = ['PWC', 'E&Y', 'DELOITTE', 'KPMG', 'ACCENTURE', 'GLOBANT', 'BCG', 'MCKINSEY'];
        const promoCode = promotionalCode.get('promotionalCode');
        const code = promoCode.get('code') && promoCode.get('code').toUpperCase();

        if (colectivos.indexOf(code) !== -1) {
            return true;
        }
    };

    const { countCurrentUploaded, countToUpload, totalValid } = filesToUpload.reduce((counters, file) => {
        const fileId = `documentToUpload_${counters.countTotal}`;
        const match = filesReceived.find(fileReceived => fileReceived.docId === file.docId);

        if (file.status === 'required') {
            countRequired++;
            totalColumns++;
        }

        if (file.docId === DOCUMENT_TYPES.DAAL && userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT) {
            return counters;
        }

        return {
            countTotal: counters.countTotal + 1,
            countCurrentUploaded: userProfile[fileId]
                ? counters.countCurrentUploaded + 1
                : counters.countCurrentUploaded,
            countToUpload: match ? counters.countToUpload + 1 : counters.countToUpload,
            totalValid: file.status === 'required' ? counters.totalValid + 1 : counters.totalValid,
        };
    }, initialCount);

    const shouldFinalizeButtonDisabled = () => {
        const allRequiredItemsAreUploaded = countRequired === countCurrentUploaded;
        const allItemsAreUploaded = totalValid - countCurrentUploaded === 0 || totalValid - countToUpload === 0;
        if (
            shouldShowTgssConsent &&
            userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT &&
            !isDocumentAccepted
        ) {
            return true;
        }

        if (
            shouldShowTgssConsent &&
            userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.UPLOAD &&
            allItemsAreUploaded
        ) {
            return false;
        }

        if (!countRequired || allRequiredItemsAreUploaded) return false;
        if (allItemsAreUploaded) return false;
        if (sendFilesDone === 'loading' || sendFilesDone === null) return true;

        return true;
    };

    const handleNavContinueAction = () => {
        const isNotDocumentAcceptedAndIsFirstAnswer =
            !isDocumentAccepted && userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT;

        if (isNotDocumentAcceptedAndIsFirstAnswer) {
            return setIsDocumentRead(true);
        }

        if (!shouldFinalizeButtonDisabled()) {
            onHandleRequestUpload();
            doTagOnFinalize();
        }

        if (shouldShowTgssConsent) {
            doTagOnTgssFinalize(userProfile);
        }

        return null;
    };

    const buildRoadmapNavigation = () => {
        const finalizeButtonDisabled = shouldFinalizeButtonDisabled();

        return (
            <div className="form__footer">
                <RoadmapNavigation
                    buttonPrevHidden
                    buttonContinueDisabled={isAres ? finalizeButtonDisabled : true}
                    buttonContinueType="submit"
                    buttonFinalizeHidden={isAres || false}
                    buttonCancelAction={handleNavCancelAction}
                    buttonContinueAction={handleNavContinueAction}
                    buttonFinalizeFakeDisabled={finalizeButtonDisabled}
                    buttonFinalizeAndContinueHidden={shouldShowQRPage}
                />
            </div>
        );
    };

    const handleOnConfirmButtonToShowNativeModal = () => {
        toggleModal();
        dropzoneRef.current();
    };

    const handleModal = (event, docId) => {
        event.stopPropagation();
        if (isUkranian() || isTransferCertificateDocument(docId)) {
            return dropzoneRef.current();
        }
        setModalType(docId);
        toggleModal();
    };

    const allUploadFileBoxes = filesToUpload.map((file, index) => {
        if (file.status === 'unrequired') return file;

        const { docTitle } = createTitleFileUploadBox({
            accountType: userProfile.accountType,
            clientRisk: userProfile.clientRisk,
            fileId: file.docId,
            filesInfoObj,
            investmentType,
            isColectivos,
            isJointHolder,
        });

        return {
            docId: file.docId,
            component: (
                <UploadFileBox
                    key={`docTitle_${file.docId}`}
                    id={index}
                    title={docTitle}
                    columnWidth={totalColumns}
                    docId={file.docId}
                    onHandleManageValidation={onHandleManageValidation}
                    onHandleFileReceived={onHandleFileReceived}
                    onHandleRemovedFile={onHandleRemovedFile}
                    handleModal={handleModal}
                    dropzoneRef={dropzoneRef}
                />
            ),
        };
    });

    const filteredBoxesToShow = shouldShowTgssConsent
        ? allUploadFileBoxes.filter(({ docId }) => docId !== DOCUMENT_TYPES.DAAL)
        : allUploadFileBoxes;

    const toggleLegalInformationModal = () => {
        setShowLegalInformationModal(prevState => !prevState);
    };

    const handleDocumentAccepted = event => {
        event.preventDefault();
        setIsDocumentAccepted(true);
        setShowLegalInformationModal(false);
    };

    const handleDocumentRead = () => {
        setIsDocumentRead(true);
    };

    return (
        <Form model="userProfile" onSubmit={handleOnSubmit}>
            <div className="prospects-gutter prospects-separator upload-documentation-container">
                {shouldShowQRPage ? (
                    <QRDocumentationView
                        userProfile={userProfile}
                        welcomeCard={immStepsState.get('welcomeCard')}
                        isDocumentRetryBeenShown={isDocumentRetryBeenShown}
                    />
                ) : (
                    <>
                        {filteredBoxesToShow.size > 0 && <UploadFiles uploadFileBoxes={filteredBoxesToShow} />}
                        {shouldShowTgssConsent && (
                            <div>
                                <h3 className="tgss-consent__title">{formatText('uploads-needYourIncomeInfo')}</h3>
                                <p className="tgss-consent__subtitle">{formatText('uploads-decideHowToUpload')}</p>
                                <RadioButton
                                    profileModel="userProfile.documentationTgssConsent"
                                    optionsList={[
                                        {
                                            label: HtmlText(formatText('uploads-tgssConsent')),
                                            value: TGSS_RADIO_VALUES.CONSENT,
                                            additionalComponent: (
                                                <WorkActivityQuestion
                                                    showModal={toggleLegalInformationModal}
                                                    isDocumentAccepted={isDocumentAccepted}
                                                    isDocumentRead={isDocumentRead}
                                                />
                                            ),
                                            showAlwaysAdditionalComponent: true,
                                        },
                                        {
                                            label: HtmlText(formatText('uploads-tgssUploadDaal')),
                                            value: TGSS_RADIO_VALUES.UPLOAD,
                                            additionalComponent: (
                                                <div className={'form-files-container daal-container'}>
                                                    {
                                                        allUploadFileBoxes.find(
                                                            ({ docId }) => docId === DOCUMENT_TYPES.DAAL
                                                        )?.component
                                                    }
                                                </div>
                                            ),
                                        },
                                    ]}
                                    isRequired
                                    disabled={false}
                                    userProfile={userProfile}
                                    userProfileForm={userProfileForm}
                                    formActions={formActions}
                                    isUpdated={() => setIsDocumentRead(false)}
                                />
                            </div>
                        )}
                        <DocumentUploadModal
                            documentType={modalType}
                            accountType={accountType}
                            onClose={toggleModal}
                            modalIsOpen={isOpen}
                            onConfirm={handleOnConfirmButtonToShowNativeModal}
                            // eslint-disable-next-line camelcase
                            profession={withoutActivity_activity}
                        />
                    </>
                )}
            </div>
            {buildRoadmapNavigation()}
            <PdfModal
                path={PDF_PATH}
                onDownloadFileName={PDF_FILE_NAME}
                showModal={showLegalInformationModal}
                toggleModal={toggleLegalInformationModal}
                isDocumentAccepted={isDocumentAccepted}
                onDocumentAccepted={handleDocumentAccepted}
                isDocumentRead={isDocumentRead}
                onDocumentRead={handleDocumentRead}
            />
        </Form>
    );
};
